var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    { 'images-after': _vm.imagesAfter },
    { 'images-before': _vm.imagesBefore } ],domProps:{"innerHTML":_vm._s(_vm.data.code)}})}
var staticRenderFns = []

export { render, staticRenderFns }